import {Component, OnInit} from '@angular/core';
import {LoginService} from '../../api/login/login.service';
import {Router} from '@angular/router';
declare var $: any;
declare var jQuery: any;
declare var $:any;
declare var jQuery:any;
@Component({
    selector: 'cat-page',
    templateUrl: './login-alpha.html'
})

export class PagesLoginAlpha implements OnInit {
    message: String;
    email: String;
    password: String;
    public role: String;
    selectedItemCategory="superadmin"
    ngOnInit() {
        this.message = "";
        $(function () {
            $('#form-validation').validate({
                submit: {
                    settings: {
                        inputContainer: '.form-group',
                        errorListClass: 'form-control-error',
                        errorClass: 'has-danger'
                    }
                }
            });
            $('.password').password({
                eyeClass: '',
                eyeOpenClass: 'icmn-eye',
                eyeCloseClass: 'icmn-eye-blocked'
            });
            this.checkId = false;
        });
    }

    constructor(private authService: LoginService,
                private router: Router) {
    }
    onCategoryChange() {
        
              
           }

    iLogin() {


        if (this.email == undefined || this.email == "") {
            $.notify({
                message: "Please Enter Email Id"
            }, {
                type: 'success',
                placement: {
                    from: 'danger',
                    align: 'right'
                }
            });
            return;
        }
        if (this.password == undefined || this.password == "") {
            $.notify({
                message: "Please Enter Password"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                }
            });
            return;
        }
        var user = {
            email: this.email,
            password: this.password,
            logintype:this.selectedItemCategory
        }
        this.login(user)
    }

    login(user) {
        this.authService.loginUser(user).then(admin => {
            console.log("admin :  "+JSON.stringify(admin))
            if (admin.status == true) {

              //  console.log("pppp  "+admin.email)
                this.authService.storeUserData(admin.data, admin.role, admin.id,admin.email);

                if (admin.role == "SUPERADMIN") {
                    this.router.navigate(['../portfolio']);
                } else if (admin.role == "ADMIN") {
                    this.router.navigate(['../blog']);
                }else if(admin.role=="BLOGGER"){
                    this.router.navigate(['../blogpost']);
                }
                else {
                    this.router.navigate(['/']);
                }

                this.message = admin.message;
                $.notify({
                    message: this.message
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    }
                });
            } else {
                this.message = admin.message;
                $.notify({
                    message: this.message
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    }
                });
                this.password = '';
                this.email = '';
            }
        })
    }
}




// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/pages/login-alpha.page.ts